import script from "./HR01_002INS.vue?vue&type=script&setup=true&lang=js"
export * from "./HR01_002INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__